import { useBusinessInfoContext } from 'contexts/BusinessContextProvider';
import { useFormField } from '../../FormElements';

export const useBusinessDetailsField = ({ fieldName, ...props } = {}) => {
  const {
    businessInfo = {},
    errors = {},
    setBusinessInfo,
    setErrors,
  } = useBusinessInfoContext() || {};

  const { [fieldName]: errorMessage } = errors;
  const { [fieldName]: fieldValue } = businessInfo;

  const setFieldValue = (value) =>
    setBusinessInfo && setBusinessInfo({ ...businessInfo, [fieldName]: value });

  const { handleOnBlur, handleOnChange } = useFormField({
    ...props,
    errors,
    isSelect: !!props?.selectList,
    fieldName,
    setErrors,
    setFieldValue,
    trackingEventName: 'businessInfo',
  });

  return { errorMessage, fieldValue, handleOnBlur, handleOnChange };
};
